import { axios } from 'lib/axios';

export const registerQuick = (data) => {
  return axios.post('/users/register/quick', data);
};
